module.exports = __webpack_public_path__ + "img/sigma.479c3ed1.png";